import { html } from "lit";
var icon_tools_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill-rule="evenodd"
      d="M8.143 21.714a2.144 2.144 0 11-.001 4.287 2.144 2.144 0 01.001-4.287zm7.857 0a2.144 2.144 0 11-.001 4.287A2.144 2.144 0 0116 21.714zm7.857 0a2.143 2.143 0 110 4.286 2.143 2.143 0 010-4.286zM8.143 13.857a2.144 2.144 0 11-.001 4.287 2.144 2.144 0 01.001-4.287zm7.857 0a2.144 2.144 0 11-.001 4.287A2.144 2.144 0 0116 13.857zm7.857 0a2.143 2.143 0 110 4.286 2.143 2.143 0 010-4.286zM8.143 6a2.144 2.144 0 11-.001 4.287A2.144 2.144 0 018.143 6zM16 6a2.144 2.144 0 11-.001 4.287A2.144 2.144 0 0116 6zm7.857 0a2.143 2.143 0 110 4.286 2.143 2.143 0 010-4.286z" />
  </svg>
`;
export {
  icon_tools_default as default
};
//# sourceMappingURL=icon-tools.js.map
